import Route from "@ember/routing/route";
import { task } from "ember-concurrency";
import { service } from "@ember/service";
import { saveRecord } from "@warp-drive/legacy/compat/builders";

export default class ShipmentsOverviewRoute extends Route {
  @service store;

  model() {
    return {
      loadShipments: this.loadShipments,
      createShipmentTask: this.createShipmentTask,
    };
  }

  loadShipments = task(async () => {
    let { project } = this.modelFor("organization");
    return await project.get("shipments");
  });

  createShipmentTask = task(async (dataCenterKey, trackingId) => {
    let { project } = this.modelFor("organization");
    let shipment = this.store.createRecord("shipment", {
      project,
      datacenter: dataCenterKey,
      trackingid: trackingId?.trim() || null,
    });

    try {
      await this.store.request(saveRecord(shipment));
    } catch (error) {
      shipment.rollbackAttributes();
      throw error;
    }

    return true;
  });
}
